import { unauthedRequest } from './requests'
/**
 *
 * /Settings resource requests
 *
 */
export const getTerms = () =>
    unauthedRequest('settings/terms', {
      method: 'GET'
      });



// WEBPACK FOOTER //
// ./src/utils/api/terms.js